import React, { useState } from "react";
import axios from "axios";
import Footer from "../components/Footer.jsx";
import { motion } from "framer-motion";
import logo from "../assets/images/logo-login.png";
import loginCar from "../assets/images/login-car.png";
import passIcon from "../assets/images/passIcon.png";
import phoneIcon from "../assets/images/phone-icon.png";
import eyeIcon from "../assets/images/eye.png";        // ⬅️ NEW
import eyeOffIcon from "../assets/images/eye-off.png"; // ⬅️ NEW
import "../styles/LoginPage.css";
import MobileFooterSheet from "../components/MobileFooterSheet.jsx";
import { API_BASE_URL } from "../utils/api";

export default function ForgotPassword({ onBack, setCurrentView }) {
  const [phone, setPhone] = useState(""); // (unused in UI but kept if you need it)
  const [password, setPassword] = useState("");
  const [password_confirmation, setPasswordConfirmation] = useState("");
  const [showNewPw, setShowNewPw] = useState(false);        // ⬅️ NEW
  const [showConfirmPw, setShowConfirmPw] = useState(false); // ⬅️ NEW
  const [submitting, setSubmitting] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    if (submitting) return;

    if (password !== password_confirmation) {
      alert("تأكيد كلمة السر غير مطابق.");
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("لا يوجد رمز مصادقة. سجّل الدخول أولاً.");
        return;
      }

      const payload = { password, password_confirmation };

      const { data } = await axios.post(`${API_BASE_URL}/reset-password`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (data?.status) {
        if (data?.token) localStorage.setItem("token", data.token);
        if (data?.user) localStorage.setItem("user", JSON.stringify(data.user));

        if (typeof setCurrentView === "function") setCurrentView("home");
        else if (typeof onBack === "function") onBack();
      } else {
        throw new Error(data?.message || "فشل إعادة تعيين كلمة المرور.");
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message ||
        "حدث خطأ غير متوقع، حاول مرة أخرى لاحقاً.";
      alert(msg);
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div dir="rtl" className="page">
      {/* Back */}
      <motion.button
        className="back-pill"
        onClick={onBack}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
      >
        <span>ارجع للخلف</span>
      </motion.button>

      <div className="shell">
        {/* Right: hero */}
        <section className="heroPane">
          <div className="brand">
            <img src={logo} alt="PARTECH" className="brand-logo" />
          </div>
          <div className="carWrap" aria-hidden>
            <img src={loginCar} alt="Sports car" />
          </div>
        </section>

        {/* Left: form */}
        <section className="formPane">
          <header className="formHeader">
            <h1>نسيت كلمة السر؟</h1>
            <p className="password-p">
              أدخل كلمة المرور الجديدة، وبنرسل لك رمز تحقق.
            </p>
          </header>

          <form onSubmit={handleReset} className="password-form">
            {/* New password with eye toggle */}
            <label className="field field--pw">
              <span className="icon" aria-hidden>
                <img src={passIcon} alt="" />
              </span>
              <div className="with-icon" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <input
                  type={showNewPw ? "text" : "password"}
                  autoComplete="new-password"
                  placeholder="كلمة السر الجديدة"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="eye-btn"
                  onClick={() => setShowNewPw((v) => !v)}
                  aria-label={showNewPw ? "إخفاء كلمة السر" : "إظهار كلمة السر"}
                  title={showNewPw ? "إخفاء" : "إظهار"}
                >
                  <img src={showNewPw ? eyeOffIcon : eyeIcon} alt="" />
                </button>
              </div>
            </label>

            {/* Confirm password with eye toggle */}
            <label className="field field--pw">
              <span className="icon" aria-hidden>
                <img src={passIcon} alt="" />
              </span>
              <div className="with-icon" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <input
                  type={showConfirmPw ? "text" : "password"}
                  autoComplete="new-password"
                  placeholder="تأكيد كلمة السر"
                  value={password_confirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  required
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="eye-btn"
                  onClick={() => setShowConfirmPw((v) => !v)}
                  aria-label={showConfirmPw ? "إخفاء كلمة السر" : "إظهار كلمة السر"}
                  title={showConfirmPw ? "إخفاء" : "إظهار"}
                >
                  <img src={showConfirmPw ? eyeOffIcon : eyeIcon} alt="" />
                </button>
              </div>
            </label>

            <button className="cta" type="submit" disabled={submitting}>
              {submitting ? "..." : "متابعة"}
            </button>
          </form>
        </section>
      </div>

      {/* Desktop footer stays; mobile footer is a bottom-sheet */}
      <div className="desktop-only">
        <Footer setCurrentView={setCurrentView} />
      </div>

      <MobileFooterSheet mode="sticky" />
    </div>
  );
}
